export const userListDemoData = [
    {
        id: 1,
        firstName: 'Christopher',
        lastName: 'Henry',
        organization: 'Bikiran',
        userName: 'christopher123',
        primaryEmail: 'christopher@gmail.com',
        primaryPhone: '8801795617763',
        primaryAddress: 'New York city, USA',
        photoUrl: '',
        timeCreated: 1701752312,
        demo: true
    },
    {
        id: 2,
        firstName: 'Christopher',
        lastName: 'Henry',
        organization: 'Bikiran',
        userName: 'christopher123',
        primaryEmail: 'christopher@gmail.com',
        primaryPhone: '8801795617763',
        primaryAddress: 'New York city, USA',
        photoUrl: '',
        timeCreated: 1701752312,
        demo: true
    }
];

export default null;
